import { useContext } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useEffectOnMount } from 'builder/hooks/useEffectOnMount'
import { GuestResumeContext } from 'builder/context/GuestResumeContext'
import { FILL_BY_URL_PARAM } from '../constants'
import { useResumePrefill } from '../hooks/useResumePrefill'

export const FillResumeByUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { handleCreateWithAi, handleUseExample, handleResumeUpload, handleStartWithLinkedIn } =
    useResumePrefill()
  const { fileForPrefill, setFileForPrefill } = useContext(GuestResumeContext)

  useEffectOnMount(() => {
    if (!searchParams.has(FILL_BY_URL_PARAM)) {
      return
    }

    const fillBy = searchParams.get(FILL_BY_URL_PARAM)

    switch (fillBy) {
      case 'createWithAi':
        handleCreateWithAi()
        break
      case 'useExample':
        handleUseExample()
        break
      case 'uploadResume':
        handleResumeUpload(fileForPrefill)
        if (fileForPrefill) {
          setFileForPrefill(null)
        }
        break
      case 'createWithLinkedIn':
        handleStartWithLinkedIn()
        break
    }

    searchParams.delete(FILL_BY_URL_PARAM)

    setSearchParams(searchParams, { replace: true })
  })

  return null
}
